import React from 'react';
import {Box, Button} from '@mui/material';
import PropTypes from 'prop-types';
import './styles.css';
import FooterPage from './FooterPage';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";


const Login = ({ onLogin, loginError }) => {
  const handleLogin = () => {
    onLogin();
  };

  return (
    <Box className="login-box">
    <div className= "container">
      <p className="popup-description" id="popup-description">
        GM Energy Home Hardware Installation
      </p>
      <p className="popup-message" id="popip-message">
        Please log in or sign up to gain access to install or perform maintenance on GM Energy home hardware.
      </p>
      <div className="login-button">
        <Button
          variant="contained"
          color="primary"
          onClick={handleLogin}
        >
          Log in / Sign up
        </Button>
        {loginError && (
            <div className="login-error">
              <ErrorOutlineIcon className="error-icon" />
              An unexpected error occurred. Please try again later.
            </div>
        )}
      </div>
    </div>
    <FooterPage />
    </Box>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default Login;